import { platformMap } from '../../constants';
import { titleCaseFromCamel } from '../../utils';

export const TransactionStatus = {
  /** Initial/starting state for DI */
  Upcoming: 'Upcoming',
  /** Initial/starting state for TA */
  Confirmed: 'Confirmed',
  /** Final state for DI */
  Paid: 'Paid',
  /** Final state for TA */
  Completed: 'Completed',
};

export const getAvailableTypes = (platform) => {
  const types = [
    { value: 'all', label: 'All' },
    ...(platform === platformMap.eatclub.value ? [{ value: 'dineIn', label: 'Dine-In' }] : []),
    { value: 'takeAway', label: 'Takeaway' },
    ...(platform === platformMap.whitelabel.value
      ? [{ value: 'tableOrder', label: 'Table Order' }]
      : []),
  ];

  return types;
};

export const formatType = (type) => {
  switch (type) {
    case 'inAppOrder':
      return 'In-App Order';
    case 'dineIn':
      return 'Dine-In';
    case 'takeAway':
      return 'Takeaway';
    case 'tableOrder':
      return 'Table Order';
    default:
      return type;
  }
};

export const formatStatus = (type, status) => {
  if (type === 'dineIn') {
    if (status === 'Confirmed') {
      return 'Upcoming'; // adds more context to the confirmed state for Dine-In
    }
  }

  return status;
};

export const formatIssueStatus = (issueStatus) => {
  if (issueStatus === 'partySizeReported') {
    return 'Party Size Changed';
  }
  return titleCaseFromCamel(issueStatus);
};
